export default "__VITE_ASSET__4lx8NXQy__"